import React from 'react';
import BooleanStep from './BooleanStep';

export default class SocialReferrerGate extends React.Component {
  render() {
    return (
      <BooleanStep
        {...this.props}
        labelText={ 'Social Referrer Gate' }
      />
    );
  }
}
